import React from "react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

import Checkbox from "./shared/Checkbox/Checkbox";
import usePreferences from "../lib/hooks/usePreferences";

const Preferences = () => {
  const { preferences, updatePreference } = usePreferences();

  return (
    <div className="absolute right-0 mr-4 -mt-8 top-0">
      <Popover>
        <PopoverButton>
          <div className="absolute right-0 rounded-full stroke-black cursor-pointer">
            <svg width="24" height="24" viewBox="0 0 14 14" fill="none">
              <path d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"></path>
              <path d="M1.16663 7.51333V6.48667C1.16663 5.88 1.66246 5.37833 2.27496 5.37833C3.33079 5.37833 3.76246 4.63167 3.23163 3.71583C2.92829 3.19083 3.10913 2.50833 3.63996 2.205L4.64913 1.6275C5.10996 1.35333 5.70496 1.51667 5.97913 1.9775L6.04329 2.08833C6.56829 3.00417 7.43163 3.00417 7.96246 2.08833L8.02663 1.9775C8.30079 1.51667 8.89579 1.35333 9.35663 1.6275L10.3658 2.205C10.8966 2.50833 11.0775 3.19083 10.7741 3.71583C10.2433 4.63167 10.675 5.37833 11.7308 5.37833C12.3375 5.37833 12.8391 5.87417 12.8391 6.48667V7.51333C12.8391 8.12 12.3433 8.62167 11.7308 8.62167C10.675 8.62167 10.2433 9.36833 10.7741 10.2842C11.0775 10.815 10.8966 11.4917 10.3658 11.795L9.35663 12.3725C8.89579 12.6467 8.30079 12.4833 8.02663 12.0225L7.96246 11.9117C7.43746 10.9958 6.57413 10.9958 6.04329 11.9117L5.97913 12.0225C5.70496 12.4833 5.10996 12.6467 4.64913 12.3725L3.63996 11.795C3.10913 11.4917 2.92829 10.8092 3.23163 10.2842C3.76246 9.36833 3.33079 8.62167 2.27496 8.62167C1.66246 8.62167 1.16663 8.12 1.16663 7.51333Z"></path>
            </svg>
          </div>
        </PopoverButton>

        <PopoverPanel transition className=" mt-6">
          <div className="flex flex-col gap-4 p-4 bg-white rounded-xl">
            <Checkbox
              id="arabicShow"
              label="Shfaq arabisht"
              checked={preferences.arabic.show}
              disabled={!preferences.translation.show}
              onChange={(e) =>
                updatePreference("arabic", "show", e.target.checked)
              }
            />

            <Checkbox
              id="translationShow"
              label="Shfaq përkthimin"
              disabled={!preferences.arabic.show}
              checked={preferences.translation.show}
              onChange={(e) =>
                updatePreference("translation", "show", e.target.checked)
              }
            />

            <Checkbox
              id="referenceShow"
              label="Shfaq referencën"
              checked={preferences.reference.show}
              onChange={(e) =>
                updatePreference("reference", "show", e.target.checked)
              }
            />
          </div>
        </PopoverPanel>
      </Popover>
    </div>
  );
};

export default Preferences;
